module.exports = __webpack_public_path__ + "img/icon-notice.45dd0d76.png";